export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14007.f88cd55c.jpg";